import * as h from "react";
import N from "react";
import { s as g } from "./styled-38387a7e.js";
import { g as _, h as x, b as M, c as C, _ as c, a as E, p as e } from "./createTheme-02ce03eb.js";
import { j as z, c as P } from "./useTheme-efe1290c.js";
import { g as U, u as W, a as w, c as H } from "./useThemeProps-ee4acb93.js";
import { T as I } from "./Typography-4117263d.js";
import { e as S } from "./elementTypeAcceptingRef-c7effbb1.js";
import { u as q } from "./useIsFocusVisible-4693b580.js";
import "@emotion/styled";
import "@emotion/react";
import "./typographyClasses-ce2680a1.js";
import "./extendSxProp-d26052ac.js";
import "./chainPropTypes-004bf492.js";
function G(o) {
  return _("MuiLink", o);
}
const J = U("MuiLink", ["root", "underlineNone", "underlineHover", "underlineAlways", "button", "focusVisible"]), K = J, k = {
  primary: "primary.main",
  textPrimary: "text.primary",
  secondary: "secondary.main",
  textSecondary: "text.secondary",
  error: "error.main"
}, Q = (o) => k[o] || o, X = ({
  theme: o,
  ownerState: n
}) => {
  const r = Q(n.color), t = x(o, `palette.${r}`, !1) || n.color, s = x(o, `palette.${r}Channel`);
  return "vars" in o && s ? `rgba(${s} / 0.4)` : M(t, 0.4);
}, Y = X, Z = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant", "sx"], oo = (o) => {
  const {
    classes: n,
    component: r,
    focusVisible: t,
    underline: s
  } = o, i = {
    root: ["root", `underline${C(s)}`, r === "button" && "button", t && "focusVisible"]
  };
  return H(i, G, n);
}, eo = g(I, {
  name: "MuiLink",
  slot: "Root",
  overridesResolver: (o, n) => {
    const {
      ownerState: r
    } = o;
    return [n.root, n[`underline${C(r.underline)}`], r.component === "button" && n.button];
  }
})(({
  theme: o,
  ownerState: n
}) => c({}, n.underline === "none" && {
  textDecoration: "none"
}, n.underline === "hover" && {
  textDecoration: "none",
  "&:hover": {
    textDecoration: "underline"
  }
}, n.underline === "always" && c({
  textDecoration: "underline"
}, n.color !== "inherit" && {
  textDecorationColor: Y({
    theme: o,
    ownerState: n
  })
}, {
  "&:hover": {
    textDecorationColor: "inherit"
  }
}), n.component === "button" && {
  position: "relative",
  WebkitTapHighlightColor: "transparent",
  backgroundColor: "transparent",
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: "pointer",
  userSelect: "none",
  verticalAlign: "middle",
  MozAppearance: "none",
  // Reset
  WebkitAppearance: "none",
  // Reset
  "&::-moz-focus-inner": {
    borderStyle: "none"
    // Remove Firefox dotted outline.
  },
  [`&.${K.focusVisible}`]: {
    outline: "auto"
  }
})), v = /* @__PURE__ */ h.forwardRef(function(n, r) {
  const t = W({
    props: n,
    name: "MuiLink"
  }), {
    className: s,
    color: i = "primary",
    component: u = "a",
    onBlur: p,
    onFocus: m,
    TypographyClasses: T,
    underline: R = "always",
    variant: f = "inherit",
    sx: l
  } = t, L = E(t, Z), {
    isFocusVisibleRef: d,
    onBlur: V,
    onFocus: F,
    ref: D
  } = q(), [j, b] = h.useState(!1), $ = w(r, D), O = (a) => {
    V(a), d.current === !1 && b(!1), p && p(a);
  }, A = (a) => {
    F(a), d.current === !0 && b(!0), m && m(a);
  }, y = c({}, t, {
    color: i,
    component: u,
    focusVisible: j,
    underline: R,
    variant: f
  }), B = oo(y);
  return /* @__PURE__ */ z.jsx(eo, c({
    color: i,
    className: P(B.root, s),
    classes: T,
    component: u,
    onBlur: O,
    onFocus: A,
    ref: $,
    ownerState: y,
    variant: f,
    sx: [...Object.keys(k).includes(i) ? [] : [{
      color: i
    }], ...Array.isArray(l) ? l : [l]]
  }, L));
});
process.env.NODE_ENV !== "production" && (v.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------
  /**
   * The content of the component.
   */
  children: e.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: e.object,
  /**
   * @ignore
   */
  className: e.string,
  /**
   * The color of the link.
   * @default 'primary'
   */
  color: e.any,
  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: S,
  /**
   * @ignore
   */
  onBlur: e.func,
  /**
   * @ignore
   */
  onFocus: e.func,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   */
  sx: e.oneOfType([e.arrayOf(e.oneOfType([e.func, e.object, e.bool])), e.func, e.object]),
  /**
   * `classes` prop applied to the [`Typography`](/material-ui/api/typography/) element.
   */
  TypographyClasses: e.object,
  /**
   * Controls when the link should have an underline.
   * @default 'always'
   */
  underline: e.oneOf(["always", "hover", "none"]),
  /**
   * Applies the theme typography styles.
   * @default 'inherit'
   */
  variant: e.oneOfType([e.oneOf(["body1", "body2", "button", "caption", "h1", "h2", "h3", "h4", "h5", "h6", "inherit", "overline", "subtitle1", "subtitle2"]), e.string])
});
const no = v, xo = g(ro)(({ theme: o }) => ({
  color: o.palette.blue.c100
}));
function ro(o) {
  return /* @__PURE__ */ N.createElement(no, { variant: "button3", ...o });
}
export {
  xo as default
};
